"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadFolder = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var method = 'post';
var bodyParams = ['abi'];
exports.uploadFolder = (0, api_utils_1.createEndpointFactory)(function () {
    return (0, api_utils_1.createEndpoint)({
        name: 'uploadFolder',
        getUrl: function () { return "/ipfs/uploadFolder"; },
        apiToResult: function (data) {
            return data;
        },
        resultToJson: function (data) { return data; },
        parseParams: function (params) { return (__assign({}, params)); },
        method: method,
        bodyParams: bodyParams,
        bodyType: api_utils_1.EndpointBodyType.BODY,
    });
});
